import { render, staticRenderFns } from "./group-choose.vue?vue&type=template&id=5c3bddd4&"
import script from "./group-choose.vue?vue&type=script&lang=js&"
export * from "./group-choose.vue?vue&type=script&lang=js&"
import style0 from "./group-choose.vue?vue&type=style&index=0&id=5c3bddd4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports